import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Icon from "../AppIcon";
import Button from "./Button";
// import lll from "../../../public/assets/images/favicon.svg";

interface NavigationItem {
  label: string;
  path: string;
}

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationItems: NavigationItem[] = [
    { label: "Home", path: "/homepage" },
    // { label: "Solutions Gallery", path: "/solutions-gallery" },
    { label: "Industry Applications", path: "/industry-applications" },
    // { label: "Technology Platform", path: "/technology-platform" },
    // { label: "Implementation Hub", path: "/implementation-hub" },
    { label: "Pricing", path: "/partner-ecosystem" },
  ];

  const isActivePath = (path: string) => location.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-brand border-b border-border">
      <div className="w-full">
        <div className="flex items-center justify-between h-16 px-4 md:px-6 lg:px-8">
          <Link
            to="/homepage"
            className="flex items-center space-x-2 hover:opacity-80 transition-opacity duration-300"
          >
            <div className="flex items-center justify-center w-10 h-10 rounded-lg">
              <img
                src="/assets/images/favicon.svg"
                alt="logo of camlytix"
              />
            </div>
            <span className="text-xl font-bold text-foreground">
              Camlytix AI
            </span>
          </Link>

          <nav className="hidden lg:flex items-center space-x-1">
            {navigationItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-all duration-300 ${
                  isActivePath(item.path)
                    ? "text-primary bg-primary/10"
                    : "text-text-secondary hover:text-foreground hover:bg-muted"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center space-x-3">
            {/* <Button
              variant="ghost"
              size="default"
              onClick={() => console.log("Calculate ROI clicked")}
            >
              Calculate ROI
            </Button> */}
            <Button
              variant="default"
              size="default"
              iconName="Play"
              iconPosition="left"
              onClick={() => console.log("See Live Demo clicked")}
              className="animate-pulse-subtle"
            >
              See Live Demo
            </Button>
          </div>

          <button
            onClick={toggleMobileMenu}
            className="lg:hidden p-2 text-foreground hover:bg-muted rounded-md transition-colors duration-300"
            aria-label="Toggle mobile menu"
          >
            <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={24} />
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden border-t border-border bg-background animate-slide-in-right">
            <nav className="flex flex-col px-4 py-4 space-y-2">
              {navigationItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`px-4 py-3 text-sm font-medium rounded-md transition-all duration-300 ${
                    isActivePath(item.path)
                      ? "text-primary bg-primary/10"
                      : "text-text-secondary hover:text-foreground hover:bg-muted"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              {/* <div className="pt-4 space-y-2 border-t border-border">
                <Button
                  variant="outline"
                  size="default"
                  fullWidth
                  onClick={() => {
                    console.log("Calculate ROI clicked");
                    setIsMobileMenuOpen(false);
                  }}
                >
                  Calculate ROI
                </Button>
                <Button
                  variant="default"
                  size="default"
                  fullWidth
                  iconName="Play"
                  iconPosition="left"
                  onClick={() => {
                    console.log("See Live Demo clicked");
                    setIsMobileMenuOpen(false);
                  }}
                >
                  See Live Demo
                </Button>
              </div> */}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
